// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-widgetwrapper-main-container {
  height: 100%;
  box-shadow: var(--chat-widget-box-shadow);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  transition: transform 1s;
  transform-origin: 100% 100%;
  display: none;
}
.chat-widgetwrapper-main-container.testFlow {
  display: flex;
  background-color: #FFF;
}
.chat-widgetwrapper-main-container.minimize {
  animation: bounce-in 0.5s ease forwards;
  display: flex;
}
.chat-widgetwrapper-main-container.minimizeQuick {
  transform-origin: bottom right;
  animation: quick 0.3s ease forwards;
  display: flex;
}
.chat-widgetwrapper-main-container.minimizeSmooth {
  transform-origin: bottom right;
  animation: quick 1s ease forwards;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/base/chatWidget/chatWidget.scss"],"names":[],"mappings":"AACA;EACI,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;EACA,aAAA;AAAJ;AACI;EACI,aAAA;EACA,sBAAA;AACR;AACI;EACI,uCAAA;EACA,aAAA;AACR;AACI;EACI,8BAAA;EACA,mCAAA;EACA,aAAA;AACR;AACI;EACI,8BAAA;EACA,iCAAA;EACA,aAAA;AACR","sourcesContent":["\n.chat-widgetwrapper-main-container{\n    height: 100%;\n    box-shadow: var(--chat-widget-box-shadow);\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    transition: transform 1s;\n    transform-origin: 100% 100%;\n    display: none;\n    &.testFlow {\n        display: flex;\n        background-color: #FFF;\n    }\n    &.minimize{\n        animation: bounce-in 0.5s ease forwards;\n        display: flex;\n      }\n    &.minimizeQuick{   \n        transform-origin: bottom right;            \n        animation: quick 0.3s ease forwards;\n        display: flex;\n    }\n    &.minimizeSmooth{   \n        transform-origin: bottom right;            \n        animation: quick 1s ease forwards;\n        display: flex;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
